// ----------------------------------------------------------------------------
// Canonical conversion constants.
//
// Single source of truth for the post-submit destination so every lead form
// lands on the SAME url. The Google Ads "Submit lead form" conversion action
// uses a page-load trigger on this path, so it must stay:
//   - bare (no query string) — the Ads trigger can then match an exact URL
//   - identical across every form — one trigger covers all lead capture
//   - noindex (already enforced via next.config.mjs X-Robots-Tag)
//
// Google Ads trigger value:  https://certbar.com/thank-you
//
// If this path ever changes, the Ads conversion action must be updated in the
// same change, otherwise conversions silently drop to zero.
// ----------------------------------------------------------------------------

export const THANK_YOU_PATH = "/thank-you";
